import { useEffect, useLayoutEffect } from "react";
import Sidebar from "../Sidebar/Sidebar";

import { Route, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import uiActions from "../../redux/ui/action";

import DashboardHeaderActions from "../StudyDashboard/components/DashboardHeaderActions";
import StudyDashboard from "../StudyDashboard/StudyDashboard";

import ExploreMotionTopBar from "./ExploreMotionTopBar";
import LoaderPopUp from "../loader/loader";

import "./DashboardLayout.css";
import {
  isDashboardHomePath,
  isExploreMotionHomePath,
  scrollDashboardPageToTop,
} from "./dashboardNavigation";
import { clearExploreCoursesScrollState } from "../DashboardCourses/utils/exploreCoursesScrollRestore";
import { clearStudyDashboardScrollState } from "../StudyDashboard/utils/studyDashboardScrollRestore";

import DashboardCourses from "../DashboardCourses/DashboardCourses";
import DashboardBooks from "../DashboardBooks/DashboardBooks";

const DashboardLayout = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const isLoaderVisible = useSelector((state) => state.ui.loader);

  const isCoursesPage =
    location.pathname === "/dashboard/courses" ||
    location.pathname.startsWith("/dashboard/courses/");

  useLayoutEffect(() => {
    if (
      !isDashboardHomePath(location.pathname) &&
      !isExploreMotionHomePath(location.pathname)
    ) {
      return;
    }
    if (isDashboardHomePath(location.pathname)) {
      clearStudyDashboardScrollState();
    } else {
      clearExploreCoursesScrollState();
    }
    scrollDashboardPageToTop();
  }, [location.pathname]);

  useEffect(() => {
    if (!isDashboardHomePath(location.pathname)) return;
    dispatch(uiActions.finishLoading());
  }, [dispatch, location.pathname]);

  useEffect(() => {
    if (
      !isDashboardHomePath(location.pathname) &&
      !isExploreMotionHomePath(location.pathname)
    ) {
      return;
    }
    scrollDashboardPageToTop();
    const frameId = window.requestAnimationFrame(scrollDashboardPageToTop);
    return () => window.cancelAnimationFrame(frameId);
  }, [location.pathname]);

  return (
    <div
      className={`dashboard-layout${
        isCoursesPage ? " dashboard-layout--courses" : ""
      }`}
    >
      {!isCoursesPage ? <Sidebar /> : null}

      <div className="dashboard-main">
        {isCoursesPage ? (
          <ExploreMotionTopBar />
        ) : (
          <div className="dashboard-top-bar">
            <DashboardHeaderActions />
          </div>
        )}

        <div className="dashboard-content">
          <Route exact path="/dashboard" component={StudyDashboard} />
          <Route exact path="/dashboard/courses" component={DashboardCourses} />
          <Route
            exact
            path="/dashboard/courses/books"
            component={DashboardBooks}
          />
        </div>
      </div>

      {isLoaderVisible ? <LoaderPopUp /> : null}
    </div>
  );
};

export default DashboardLayout;
